import styled from 'styled-components';

import { Link as RouterLink } from 'react-router-dom';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  height: 100%;

  background-color: #0f113e;
`;

export const Content = styled.div`
  text-align: center;
`;

export const Message = styled.div`
  font-size: 60px;
  color: #ffffff;
`;

export const Link = styled(RouterLink)`
  text-decoration: none;

  font-size: 20px;
  color: #90ca28;
`;
